// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SJ8J","importantInfo":"styles_importantInfo__2dOkm"};